export const PERIODS_BY_CAMPUS: any = {
  "M": [
    "4:30PM - 6:00PM",
    "6:10PM - 7:40PM",
  ],
  "T": [
    "4:30PM - 6:00PM",
    "6:10PM - 7:40PM",
  ],
  "W": [
    "4:30PM - 6:00PM",
    "6:10PM - 7:40PM",
  ],
  "R": [
    "4:30PM - 6:00PM",
    "6:10PM - 7:40PM",
  ],
  "F": [
    "4:30PM - 6:00PM",
    "6:10PM - 7:40PM",
  ],
  "S": [
    "9:30AM - 11:00AM",
    "11:00AM - 12:30PM",
    "1:30PM - 3:00PM",
    "3:00PM - 4:30PM",
    "4:30PM - 6:00PM",
    "6:10PM - 7:40PM",
  ],
  "U": [
    "9:30AM - 11:00AM",
    "11:00AM - 12:30PM",
    "1:30PM - 3:00PM",
    "3:00PM - 4:30PM",
    "4:30PM - 6:00PM",
    "6:10PM - 7:40PM",
  ],
  "A": [
    "9:30AM - 11:00AM",
    "11:00AM - 12:30PM",
    "1:30PM - 3:00PM",
    "3:00PM - 4:30PM",
    "4:30PM - 6:00PM",
    "6:10PM - 7:40PM",
  ],
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/constants/periods.ts